import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import API, { auth } from '../../constants/api'
import {
  FORGOT_PASSWORD,
  SET_PASSWORD
} from '../actions'

import {
  forgotPasswordFetchSuccess,
  forgotPasswordFetchFail,
  setPasswordFetchSuccess,
  setPasswordFetchFail
} from './actions'

/* forgot password */
const forgotPasswordFetchAsync = async (req) =>
  await API.post('/auth/forgotpassword', {
    "memberEmail": req.memberEmail
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* forgotPasswordFetch({ payload }) {
  const { forgotPassword } = payload
  // console.log('forgotPassword -> ', forgotPassword)
  try {
    const forgotPasswordFetch = yield call(forgotPasswordFetchAsync, forgotPassword)

    if (forgotPasswordFetch.data.StatusCode === '0000') {
      yield put(forgotPasswordFetchSuccess(forgotPasswordFetch.data.ResultValues))
    } else {
      yield put(forgotPasswordFetchFail(forgotPasswordFetch.data.Message))
    }
  } catch (error) {
    yield put(forgotPasswordFetchFail(error))
  }
}

/* set password */
const setPasswordFetchAsync = async (req) =>
  await API.post('/auth/setnewpassword', {
    "token": req.token,
    "password": req.password
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* setPasswordFetch({ payload }) {
  const { setPassword } = payload
  // console.log('setPassword -> ', setPassword)
  try {
    const setPasswordFetch = yield call(setPasswordFetchAsync, setPassword)

    if (setPasswordFetch.data.StatusCode === '0000') {
      yield put(setPasswordFetchSuccess(setPasswordFetch.data.ResultValues))
    } else {
      yield put(setPasswordFetchFail(setPasswordFetch.data.Message))
    }
  } catch (error) {
    yield put(setPasswordFetchFail(error))
  }
}

export function* watchForgotFetch() {
  yield takeEvery(FORGOT_PASSWORD, forgotPasswordFetch)
  yield takeEvery(SET_PASSWORD, setPasswordFetch)
}

export default function* rootSaga() {
  yield all([fork(watchForgotFetch)])
}